<template>
	<div>
		<Header :links="header" :class="{ 'header': true, 'header--loaded': true }" role="heading" aria-level="1" />
		<NuxtLayout name="page">
			<h1>Fehler {{ error.status }}</h1>
			<p>
				{{ errorMessage }}
			</p>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { header } from '~/assets/config/navigation.json'
const { error } = defineProps<{error: NuxtError}>()

const errorMessage = computed(() =>
{
	switch( error.status || 404 )
	{
		case 400: return 'Fehlerhafte Anfrage.'
		case 403: return 'Sie haben keine Berechtigung diese Seite anzuzeigen.'
		case 404: return `Seite nicht gefunden: ${(error.data as any).path}.`
		case 500: return 'Interner Serverfehler.'
	}

	return 'Ein unbekannter Fehler ist aufgetreten.'
})
</script>

<style lang="css" scoped>
h1, p
{
	text-align: center;
}
</style>